<template>
  <div class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="0" />
    <div v-else>
    <h2>{{ listTitle }}</h2>
    <LmBreadcrumb/>
    <LmTableCustom
      :order = order
      :orderBySetting = orderBySetting
      :perPageSetting = perPageSetting
      :itemsPerPage = defaultItemsPerPage
      :limitExportFromClient = limitExportFromClient
      :apiCallPath = apiCallPath
      :highlight = highlight
      :actions = actions
      :showFilterTime = showFilterTime
      :downloadCsvFileName = downloadCsvFileName
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import LmTableCustom from '@/components/LmTableCustom'
export default {
  methods: {
    ...mapActions('settings', ['getListSettings'])
  },
  computed: {
    ...mapState('settings', [
      'listTitle',
      'order',
      'orderBySetting',
      'perPageSetting',
      'defaultItemsPerPage',
      'limitExportFromClient',
      'loading',
      'highlight',
      'apiCallPath',
      'actions',
      'showFilterTime',
      'downloadCsvFileName'
    ])
  },
  components: {
    LmTableCustom
  },
  props: ['listEndpointUri'],
  created () {
    this.getListSettings(this.listEndpointUri)
  }
}
</script>

<style lang="sass" scoped>
  table
    margin: 16px
</style>
